import request from "@/utils/request"

export function systemConfigAll(group) {
  return request.get('/systemConfig', {params: {group: group}})
}

export function systemConfigStore(data) {
  return request.post('/systemConfig', data)
}